
(function() {
  var result = { translations: { "zh-cn": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u949F", "hours": "{{ hours }} \u5C0F\u65F6", "hoursAndMinutes": "{{ hours }} \u5C0F\u65F6 {{ minutes }} \u5206\u949F", "days": "{{ days }} \u5929", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u949F", "hours": "{{ hours }} \u5C0F\u65F6", "days": "{{ days }} \u5929", "hoursAndMinutes": "{{ hours }} \u5C0F\u65F6 {{ minutes }} \u5206\u949F" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63\u5EA6" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\uFF0C\u5206\u673A {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "zh-cn": "static-7.1052"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1052",
    "ar-eg": "static-7.1052",
    "bg": "static-7.1052",
    "bn": "static-7.1052",
    "ca-es": "static-7.1052",
    "cs": "static-7.1052",
    "da": "static-7.1052",
    "de": "static-7.1052",
    "el": "static-7.1052",
    "en-gb": "static-7.1052",
    "en": "static-7.1052",
    "es-mx": "static-7.1052",
    "es": "static-7.1052",
    "et": "static-7.1052",
    "fi": "static-7.1052",
    "fr-ca": "static-7.1052",
    "fr": "static-7.1052",
    "he-il": "static-7.1052",
    "hi": "static-7.1052",
    "hr": "static-7.1052",
    "hu": "static-7.1052",
    "id": "static-7.1052",
    "it": "static-7.1052",
    "ja": "static-7.1052",
    "ko": "static-7.1052",
    "lt": "static-7.1052",
    "ms": "static-7.1052",
    "nl": "static-7.1052",
    "no": "static-7.1052",
    "pl": "static-7.1052",
    "pt-br": "static-7.1052",
    "pt-pt": "static-7.1052",
    "ro": "static-7.1052",
    "ru": "static-7.1052",
    "sk": "static-7.1052",
    "sl": "static-7.1052",
    "sv": "static-7.1052",
    "th": "static-7.1052",
    "tl": "static-7.1052",
    "tr": "static-7.1052",
    "uk": "static-7.1052",
    "vi": "static-7.1052",
    "x-pseudo": "static-7.1052",
    "zh-cn": "static-7.1052",
    "zh-hk": "static-7.1052",
    "zh-tw": "static-7.1052"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-cn', {version: 'static-7.1052'}); }
})();


